import { eq } from 'fp-ts';
import { useRef } from 'react';

/** Keeps the first reference for successively equal values.
 *  Useful for react hooks, where nonprimitive types are checked for reference equality only. */
export const useSameReferenceCache = <T>(value: T, eqStruct: eq.Eq<T>) => {
    const savedInstanceRef = useRef(value);

    if (!eqStruct.equals(value, savedInstanceRef.current)) {
        savedInstanceRef.current = value;
    }

    return savedInstanceRef.current;
};
